import { useState } from "react";
import { MyTooltip } from "./MyTooltip";
import { handleCopyText } from "../uiHelpers";

export type CopyTooltipProps = {
  text: string;
  children: React.ReactElement<any, any>;
};

export const CopyTooltip = ({ text, children }: CopyTooltipProps) => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = () => {
    setCopied(true);
    handleCopyText(text);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <MyTooltip onClick={handleCopy} title={copied ? "Copied!" : "Copy"}>
      {children}
    </MyTooltip>
  );
};
